import _styled, { default as _styled2 } from "styled-components";
import { m, type MotionProps } from "framer-motion";
type Props = MotionProps & {
  left?: React.ReactNode;
  right?: React.ReactNode;
};
export function ProductHeroBottomRow(props: Props) {
  const {
    left,
    right,
    ...rest
  } = props;
  return <_StyledMDiv {...rest}>
      <_StyledDiv>{left}</_StyledDiv>
      <div>{right}</div>
    </_StyledMDiv>;
}
var _StyledMDiv = _styled(m.div).withConfig({
  componentId: "sc-sf-2tk94a-0"
})({
  "position": "relative",
  "zIndex": "10",
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "alignItems": "flex-start",
  "gap": "2.4rem",
  "padding": "4rem",
  "--tw-text-opacity": "1",
  "color": "rgb(255 255 255 / var(--tw-text-opacity))",
  "@media (min-width: 1024px)": {
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "space-between",
    "gap": "8rem",
    "padding": "8rem"
  }
});
var _StyledDiv = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "product-hero-bottom-row___StyledDiv",
  componentId: "sc-1b0aamv-0"
})({
  "maxWidth": "72rem"
});